import { Controller } from "@hotwired/stimulus";
import gsap from "gsap";

export default class extends Controller {
  static targets = ["overlay", "icon", "iconWrapper"];

  connect() {
    gsap.set(this.overlayTarget, {
      opacity: 0,
      display: "none",
    });
  }

  toggle() {
    const isHidden = this.overlayTarget.style.display === "none";
    if (isHidden) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    this.iconTarget.classList.remove("fa-plus");
    this.iconTarget.classList.add("fa-minus");
    this.iconWrapperTarget.classList.remove(
      "bg-primary-500",
      "text-neutral-0",
      "group-hover/teamcard:bg-primary-700",
    );
    this.iconWrapperTarget.classList.add("bg-neutral-0", "text-brand");

    gsap.to(this.overlayTarget, {
      display: "flex",
      opacity: 1,
      duration: 0.3,
      ease: "power2.out",
    });
  }

  hide() {
    this.iconTarget.classList.remove("fa-minus");
    this.iconTarget.classList.add("fa-plus");
    this.iconWrapperTarget.classList.remove("bg-neutral-0", "text-brand");
    this.iconWrapperTarget.classList.add(
      "bg-primary-500",
      "text-neutral-0",
      "group-hover/teamcard:bg-primary-700",
    );

    gsap.to(this.overlayTarget, {
      opacity: 0,
      duration: 0.3,
      ease: "power2.in",
      onComplete: () => {
        gsap.set(this.overlayTarget, { display: "none" });
      },
    });
  }
}
